module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-41.17a0c12a.jpg";